module.exports = __webpack_public_path__ + "img/user.3fae868f.png";